
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M21.677 3.322a.75.75 0 10-1.354-.644l-4.568 9.592-4.253-3.827a.75.75 0 00-1.173.222l-4 8a.75.75 0 101.342.67l3.56-7.119 4.267 3.841a.75.75 0 001.18-.235l5-10.5zM3.75 3a.75.75 0 00-1.5 0v18c0 .414.336.75.75.75h18a.75.75 0 000-1.5H3.75V3z"}})])
          )
        }
      }
    